<template>
  <Modal
    :width="480"
    name="HAUSEFUL_INVOICE_GENERATE_ASAAS_MODAL"
    :title="$t('hausefulInvoices.modals.generateAsaas.title')"
    actions
  >
    <template v-slot:body>
      <p class="body-2">
        {{ $t('hausefulInvoices.modals.generateAsaas.message') }}
      </p>
      <v-card class="py-4 px-4 my-3" color="grey lighten-3" outlined>
        <h6 class="text-uppercase grey--text">
          {{ $t('hausefulInvoices.realEstate') }}
        </h6>
        <span class="body-2 d-block">
          {{ hausefulInvoiceInfo.realEstate }}
        </span>
        <span v-if="hausefulInvoiceInfo.branch" class="body-2 d-block grey--text">
          {{ $t('hausefulInvoices.subsidiary') }}: {{ hausefulInvoiceInfo.branch }}
        </span>
        <span class="body-2 d-block success--text font-weight-bold mt-2">
          {{ $t('hausefulInvoices.total') }}: {{ totalAmount }}
        </span>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isLoading"
        class="grey--text"
        elevation="0"
        text
      >
        {{ $t('hausefulInvoices.modals.defaultActions.cancel') }}
      </v-btn>
      <v-btn
        @click="generateInvoice"
        :loading="isLoading"
        elevation="0"
        class="ml-5"
        color="primary"
      >
        {{ $t('hausefulInvoices.modals.generateAsaas.action') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import Modal from '@/components/app/Modal'
import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'ModalHausefulInvoiceGenerateAsaas',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['isLoading', 'hausefulInvoiceInfo']),

    totalAmount() {
      return catalogMonetary(this.hausefulInvoiceInfo.total ?? 0.00)
    },
  },

  methods: {
    ...mapActions(['generateAsaasHausefulInvoice']),
    ...mapMutations(['closeAllModals']),

    generateInvoice() {
      this.generateAsaasHausefulInvoice()
    },
  },
}
</script>
